import React from 'react';
import { ScreenController } from 'src/feature-app';
import { NavidadGTI2025Form } from 'src/forms/FormsAdhoc/NavidadGTI2025/NavidadGTI2025Form';

export function NavidadGTI2025Trigger() {
  return <ScreenController
    selectedJourney={<NavidadGTI2025Form />}
    closeLayerCallback={close}
    handleAreYouSureLayer={() => null}
    notALayer={true}
    formType='module'
  />;
}
